export default "__VITE_PUBLIC_ASSET__8f511a24__"